export const PROVIDER_MOCK = 'MOCK'

export const PROVIDER_API = 'API'

export const PROVIDER_FIREBASE = 'FIREBASE'
